import DeviceGroupVideosTab from './DeviceGroupVideosTab';

export default DeviceGroupVideosTab;
